/** Whole seconds to wait, rounded up so a partial second never enables resend early. */
export function resendSeconds(deadline: Date | null, nowSeconds: number): number {
  if (!deadline || !Number.isFinite(deadline.getTime())) return 0;
  return Math.max(0, Math.ceil(deadline.getTime() / 1000) - nowSeconds);
}
